import * as lodash from 'lodash'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { routes } from '@tv3/app-routing.module'

const urls = routes.filter((r) => lodash.get(r, 'data.noMasterLayout')).map((r) => r.path)

@Injectable({
  providedIn: 'root',
})
export class SkipMasterLayoutService {
  constructor(private router: Router) {}

  public check(): boolean {
    return !!urls.find((url) => this.router.isActive(url, false))
  }
}
